import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { PROJECT_ORGANISATION_ROLE as orgaRole } from '../../../utils/constant';
import ProjectSelectRoleCard from '../ProjectSelectRoleCard/ProjectSelectRoleCard';
import ProcurementContact from '../../ProcurementContact/ProcurementContact';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const availableProjectRoles = [orgaRole.PROJECT_CLIENT, orgaRole.PROJECT_CLIENT_DELEGATE, orgaRole.PROJECT_CLIENT_ASSISTANT, orgaRole.PROJECT_MANAGER, orgaRole.PROJECT_GENERAL_CONTRACTOR_OWNER];
const ProjectRoleForm = props => {
  const [currRole, setCurrRole] = useState(props.projectRole);
  function shouldDisplayProcurementContact(role) {
    return props.projectDetails?.publicProcurement && [orgaRole.PROJECT_CLIENT, orgaRole.PROJECT_CLIENT_DELEGATE].includes(role);
  }
  function handleSelectedRole(role) {
    setCurrRole(role);
    if (!shouldDisplayProcurementContact(role)) {
      props.onValidate(role);
    }
  }
  function onDefineProcurementContact(pc) {
    props.onProcurementContact(pc);
    props.onValidate(currRole);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(Translate, {
        value: "project.role.notice"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "row",
      children: availableProjectRoles.map((role, index) => {
        const isSelected = currRole === role;
        return /*#__PURE__*/_jsx(ProjectSelectRoleCard, {
          isSelected: isSelected,
          onRoleSelection: handleSelectedRole,
          role: role,
          "data-id": `${role}-selection`
        }, index);
      })
    }), shouldDisplayProcurementContact(currRole) && /*#__PURE__*/_jsx(ProcurementContact, {
      onProcurementContact: onDefineProcurementContact,
      organisation: props.organisation,
      "data-id": "procurement-contact-selection"
    })]
  });
};
ProjectRoleForm.propTypes = {
  onValidate: PropTypes.func.isRequired,
  onProcurementContact: PropTypes.func.isRequired,
  projectDetails: PropTypes.object,
  organisation: PropTypes.object,
  projectRole: PropTypes.oneOf(Object.values(orgaRole))
};
export default ProjectRoleForm;